import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const ProductOverview = () => {
  const features = ['+240 páginas de contenido estructurado', '60+ clases completas listas para dar', 'Clásico · Fuerza · Flow · Elementos · Adultos Mayores · Full Power', 'Planificación · Variaciones · Fidelización · Comunicación', 'Funciona desde hoy mismo en tu estudio'];
  const levels = ['Principiante', 'Intermedio', 'Avanzado', 'Adultos Mayores', 'Flow', 'Full Power'];
  return <section className="py-8 md:py-14 bg-sage-900 text-white relative overflow-hidden" data-id="element-253">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-254">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-sage-400 rounded-full blur-3xl" data-id="element-255"></div>
        <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-gold rounded-full blur-3xl" data-id="element-256"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-258">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-gold/20 text-gold-light rounded-full text-xs font-bold tracking-widest uppercase mb-4 md:mb-8 border border-gold/30" data-id="element-259">
            <span className="text-sm" data-id="element-260">🏆</span> Sistema N°1 para Instructoras en
            Argentina
          </div>

          <h2 className="text-4xl md:text-7xl font-bold text-white mb-2 md:mb-4 font-playfair tracking-tight" data-id="element-261">
            PILATES 360™
          </h2>
          <h3 className="text-xs md:text-base text-sage-300 font-light mb-4 md:mb-8 uppercase tracking-[0.2em]" data-id="element-262">
            MEGAPACK — SISTEMA COMPLETO
          </h3>

          <p className="text-base md:text-2xl text-white/90 font-medium mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-263">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 text-left bg-white/5 backdrop-blur-sm p-5 md:p-12 rounded-2xl md:rounded-3xl border border-white/10" data-id="element-264">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-265">
            <ul className="space-y-3 md:space-y-4" data-id="element-266">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-2 md:gap-3" data-id="element-267">
                  <CheckCircle2 className="w-5 h-5 text-gold flex-shrink-0" data-id="element-268" />
                  <span className="text-sm md:text-lg text-white/90" data-id="element-269">
                    {feature}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex flex-col justify-center" data-id="element-270">
            <p className="text-xs text-sage-300 uppercase tracking-wider font-semibold mb-3 md:mb-4" data-id="element-271">
              Niveles y Enfoques Incluidos:
            </p>
            <div className="flex flex-wrap gap-2 md:gap-3" data-id="element-272">
              {levels.map((level, index) => <span key={index} className="px-3 py-1.5 bg-sage-800 border border-sage-700 rounded-lg text-xs font-medium text-sage-100" data-id="element-273">
                  {level}
                </span>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};